import { render, staticRenderFns } from "./organConfig.vue?vue&type=template&id=31317396&scoped=true"
import script from "./organConfig.vue?vue&type=script&lang=ts"
export * from "./organConfig.vue?vue&type=script&lang=ts"
import style0 from "./organConfig.vue?vue&type=style&index=0&id=31317396&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31317396",
  null
  
)

export default component.exports